import Auth0 from 'auth0-js';

import { appConfig } from 'src/app';

const METADATA_ATTR_URL = 'https://vitastudent.com/user_metadata';

const auth0 = new Auth0.WebAuth({
    domain: appConfig.auth0.authDomain as string,
    clientID: appConfig.auth0.authClientId as string,
    redirectUri: `${window.location.origin}/callback`,
    audience: appConfig.auth0.authAudience as string,
    responseType: 'token id_token',
    scope: 'openid profile email read:current_user create:current_user_metadata update:current_user_metadata',
});

export { METADATA_ATTR_URL, auth0 };
